import React from "react";
import {
  PieChart,
  Pie,
  Cell,

  Tooltip,
} from "recharts";
import styles from './Allocation.module.css'; // Import the CSS module
const pieData = [
  { name: "Unlocked (30%)", value: 30 },
  { name: "Locked (70%)", value: 70 },
];


const COLORS = ["#B29179", "#573e09"];

const TokenAllocation = () => {
  return (
   <section className={styles['yzy-launch-container']}>
     <div className={styles['yzy-text-container']} >
      <h2>Token Allocation</h2>
      <p>
        There are <strong>200 million</strong> $YZY available on day one and
        the total supply grows to <strong>1 billion</strong> $YZY  over 3 years.
        Each group’s allocation is released on its own schedule, and{" "}
        <strong>70% is locked</strong> according to the vesting schedule.
      </p>
      </div>
      {/* Pie Chart for Quick Snapshot of Locked vs Unlocked */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <PieChart width={500} height={300}>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, value }) => `${name} (${value}%)`}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </div>

      {/* Bar Chart for Monthly Unlock Schedule */}

            </section>
  );
};

export default TokenAllocation;